import { createFileRoute } from "@tanstack/react-router";
import MeetRex from "@/pages/MeetRex";

export const Route = createFileRoute("/meet-rex")({
  head: () => ({
    meta: [
      { title: "Meet Rex | AI RV Expert | Rex & Sons RVs" },
      {
        name: "description",
        content:
          "Meet Rex, your AI RV Expert. Answer a few quick questions and get matched with the perfect new or used RV from Rex & Sons RVs in Castle Hayne, NC.",
      },
      { property: "og:title", content: "Meet Rex | AI RV Expert | Rex & Sons RVs" },
      {
        property: "og:description",
        content:
          "Meet Rex, your AI RV Expert. Answer a few quick questions and get matched with the perfect RV.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: MeetRex,
});
